<template>
  <div class="sidebar">
    <div class="logo">
      <div class="logo__icon">
        <router-link to="/">
          <object 
            type="image/svg+xml" 
            :data="THEME === 'domion' ? logoSvg : logoGreen" 
            width="42" 
            :class="THEME === 'domion' ? 'logo__icon-svg' : ''"
          >
            Your browser does not support SVG
          </object>
        </router-link>
      </div>
      <div class="logo__content">
        <div class="logo__content-title" :style="THEME === 'domion' ? '' : 'color:black'">{{ logoTitle }}</div>
        <div v-if="role === 'CLIENT'" class="logo__content-subtitle">Личный кабинет</div>
      </div>
    </div>

    <sidebar-select v-if="role === 'CLIENT'" :items="apartments" :chosen-item="apartments[0]" />

    <div class="sidebar__links">
      <router-link v-for="(item, idx) in data" :key="idx" active-class="sidebar__item_active" :to="item.url" :class="[
        'sidebar__item',
        {
          'is-disabled': item.disabled,
        },
      ]">
        <div class="sidebar__wrapper" @click="toggleChildren(item, data)">
          <div class="sidebar__item-icon">
            <mdicon :name="item.icon" />
          </div>
          <div class="sidebar__item-text">{{ item.name }}</div>
        </div>

        <div class="sidebar__subitems" v-if="item.isOpen">
          <router-link v-for="(subitem, idx) in item.items" :key="idx" :to="subitem.url" class="sidebar__subitem"
            active-class="sidebar__subitem_active">
            <div class="sidebar__subitem-text">{{ subitem.name }}</div>
          </router-link>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import SidebarSelect from '@/components/atoms/components/SidebarSelect';
import { useStore } from 'vuex';
import { useQuery } from '@vue/apollo-composable';
import { getMyApartments } from '@/graphql/Login.graphql';
// import { THEME } from '@/constant/main'
const THEME = process.env.VUE_APP_THEME;
// TODO: import component
defineProps({
  data: { default: [] }
})

const logoSvg = require('@/assets/images/logo-domion.svg');
const logoGreen = require('@/assets/images/claims-green/inner-logo.svg');
const logoTitle = ref(process.env.VUE_APP_THEME === 'domion' ? 'домион' : 'ГРИН.ДОМ');
const store = useStore();
const role = store.getters['app/userRole'];
const apartments = ref([{ name: '' }]);

const { result: myApartmentsResult } = useQuery(getMyApartments);

const toggleChildren = (item, data) => {
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    element.isOpen = false;
  }
  item.isOpen = !item.isOpen;
};

function renameAddressKeyToName(arr) {
  return arr.map(item => {
    const { address, ...rest } = item;
    if ('address' in item) {
      return { name: address, ...rest };
    }
    return item;
  });
}

watch(myApartmentsResult, (value) => {
  apartments.value = renameAddressKeyToName(value.getMyApartments);
});
</script>

<style lang="scss" scoped>
@import 'src/assets/styles/_colors';

.sidebar {
  padding: 0 0 16px 0;
  height: auto;
  width: 255px;
  font-family: Golos;
  background: map-get($sidebar, 'bg');
  overflow-y: scroll;
  -ms-overflow-style: none;
  /* for Internet Explorer, Edge */
  scrollbar-width: none;
  /* for Firefox */

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: block;
  }

  .logo {
    margin-left: 16px;
    display: flex;
    align-items: center;

    &__icon {
      margin-right: 15px;
      display: flex;
      align-items: center;
      height: 88px;

      &-svg {
        filter: var(--primary-svg);
      }
    }

    &__content {
      color: var(--primary-color);
      font-weight: 700;

      &-title {
        margin-bottom: 5px;
        font-size: 24px;
      }

      &-subtitle {
        font-size: 14px;
      }
    }
  }

  &__links {
    margin-top: 24px;
    padding-left: 16px;
  }

  &__wrapper {
    display: flex;
    align-items: center;
    padding: 18px 14px;
  }

  &__item {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    color: map-get($primary-text, 'normal');
    margin-bottom: 16px;

    &:hover,
    &_active {
      color: map-get($primary-text, 'hover');
      cursor: pointer;
      background-color: var(--white);
    }

    &-icon {
      margin-right: 10px;
    }

    &-text {
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
    }

    &.is-disabled {
      opacity: 0.4;
      pointer-events: none;
      cursor: default;
    }
  }

  &__subitems {
    display: flex;
    flex-direction: column;
  }

  &__subitem {
    display: flex;
    flex-direction: column;
    padding: 7px 0 11px 48px;
    text-decoration: none;
    color: map-get($primary-text, 'normal');

    &:hover,
    &_active {
      background-color: var(--primary-light-opacity-color);
    }

    &-text {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
    }
  }
}
</style>
